<app-loader *ngIf="dataIsLoaded==false"></app-loader>
<ng-container *ngIf="displayById == true">
	<header class="background-header"></header>
	<section class="main-side-nav" id="mainSideNav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
		<section class="container admin-dashboard-parent accounts-container">
			<section class="template-section-title">
				<div class="breadcrumb-container">
					<span>Admin <i class="fa fas fa-chevron-right"></i></span>
					<app-breadcrumb [pageName]="'Mail Log'" [isTopLevel]="true"></app-breadcrumb>
				</div>
				<div class="title-container">
					<h1>Mail Log</h1>
				</div>
			</section>

			<section class="user-dashboard">
				<div class="user-name">
					<div class="info-user">
						<h2 class="user-name" *ngIf="userById.firstName || userById.lastName">{{userById.firstName + " " + userById.lastName}}</h2>
						<h2 class="user-name" *ngIf="!userById.firstName || !userById.lastName">User Name</h2>
						<h6 *ngIf="!userById.firstName || !userById.lastName">(Apparently, this user has not registered a name.)</h6>
					</div>
					<div class="back-btn">
						<input type="button" class="btn btn-primary back-btn" value="Back" (click)="goBackUserById()">
					</div>
				</div>
			</section>

			<section class="all-users-data">
				<div class="table-responsive admin-dashboard-table">
					<table class="table table-bordered table-hover">
						<thead>
							<tr>
								<th scope="col">Email Sent</th>
								<th scope="col">Data Sent</th>
								<th scope="col">Date</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let emailHistory of userById.email_history">
								<td>{{userById.email}}</td>
								<td>{{emailHistory.template}}</td>
								<td>{{emailHistory.date | date: 'dd/MM/yyyy, h:mm a'}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
		</section>
	</section>
</ng-container>

<div *ngIf="dataUser || showDetailUser == true" id="userDetail">
	<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
		<section class="container admin-dashboard-details account-details-container">
			<section class="template-section-title">
				<div class="breadcrumb-container">
					<span>Admin <i class="fa fas fa-chevron-right"></i></span>
					<app-breadcrumb [pageName]="'Mail Log'" [isTopLevel]="true"></app-breadcrumb>
				</div>
				<div class="title-container">
					<h1>Mail Log</h1>
				</div>
			</section>

			<section class="user-dashboard">
				<div class="user-name">
					<div class="info-user">
						<ng-container *ngIf="displayById == false">
							<h2 class="user-name" *ngIf="dataUser.firstName || dataUser.lastName">{{dataUser.firstName + " " + dataUser.lastName}}</h2>
							<h2 class="user-name" *ngIf="!dataUser.firstName || !dataUser.lastName">User Name</h2>
							<h6 *ngIf="!dataUser.firstName || !dataUser.lastName">(Apparently, this user has not registered a name.)</h6>
						</ng-container>
						<ng-container *ngIf="displayById == true">
							<h2 class="user-name" *ngIf="userById.firstName || userById.lastName">{{userById.firstName + " " + userById.lastName}}</h2>
							<h2 class="user-name" *ngIf="!userById.firstName || !userById.lastName">User Name</h2>
							<h6 *ngIf="!userById.firstName || !userById.lastName">(Apparently, this user has not registered a name.)</h6>
						</ng-container>
						
					</div>
					<div class="back-btn">
						<input *ngIf="displayById == false" type="button" class="btn btn-primary back-btn" value="Back" (click)="goBack()">
						<input *ngIf="displayById == true" type="button" class="btn btn-primary back-btn" value="Back" (click)="goBackUserById()">
					</div>
				</div>
			</section>

			<!-- Table Data -->
			<section class="all-users-data">
				<div class="table-responsive admin-dashboard-table">
					<table class="table table-bordered table-hover">
						<thead>
							<tr>
								<th scope="col">Email Sent</th>
								<th scope="col">Data Sent</th>
								<th scope="col">Date</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="displayById == false">
								<tr *ngFor="let emailHistory of dataUser.email_history">
									<td>{{dataUser.email}}</td>
									<td>{{emailHistory.template}}</td>
									<td>{{emailHistory.date | date: 'dd/MM/yyyy, h:mm a'}}</td>
								</tr>
							</ng-container>
							
							<ng-container *ngIf="displayById == true">
								<tr *ngFor="let emailHistory of userById.email_history">
									<td>{{userById.email}}</td>
									<td>{{emailHistory.template}}</td>
									<td>{{emailHistory.date | date: 'dd/MM/yyyy, h:mm a'}}</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
			</section>
		</section>
	</section>
</div>